import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import {
  setIsModalxOpen,
  setDestroy as setModalxDestroy,
} from "components/modalx/modalx.slice";
import { post } from "../products/products.service";
import { fetchProducts } from "../products/products.slice";

const initialState = {
  isLoading: false,
  isError: false,
  isSuccessfullySaved: false,
  errMsg: null,
  successMessage: null,
};
const productFormSlice = createSlice({
  name: "productForm",
  initialState,
  /* eslint-disable no-param-reassign */
  reducers: {
    setLoading(state) {
      state.isLoading = true;
    },
    setError(state, action) {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = action.payload.error;
    },
    setSuccessfullySaved(state, action) {
      state.isLoading = false;
      state.isError = false;
      state.errMsg = null;
      state.successMessage = action.payload;
    },
    destroy(state) {
      _.assign(state, initialState);
    },
  },
  /* eslint-enable */
});

// Extract the action creators object and the reducer
const { actions, reducer } = productFormSlice;

// Extract and export each action creator by name
export const {
  setLoading,
  setError,
  setSuccessfullySaved,
  destroy,
  setVatsOptions,
} = actions;

// Export the reducer, either as a default or named export
export default reducer;

export const submit = (companyId, data) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const result = await post(companyId, data);
    // Fully reset modalx so list screens that watch `component` (not only
    // isOpen) still refresh after create/edit — same pattern as other forms.
    dispatch(setIsModalxOpen(false));
    dispatch(setModalxDestroy());
    // Best-effort refresh of the legacy products reducer; ignore failures so
    // create/edit success is not blocked by that unused list path.
    try {
      await dispatch(fetchProducts(companyId));
    } catch (e) {
      /* no-op */
    }
    dispatch(setSuccessfullySaved("saved"));

    const id =
      _.get(result, "createdProduct.id") || _.get(result, "updatedProduct.id");
    if (id) {
      return id;
    }
  } catch (e) {
    dispatch(setError({ error: "not_saved" }));
    return false;
  }
};
